// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"066430b9","124":"6766ed68","150":"188c4ada","291":"58f41312","331":"d404ccce","349":"b38d0f1f","564":"0799f304","603":"e3e13328","663":"e19dbbfb","673":"b270e393","721":"67bea677","769":"fb72687e","852":"159a1e32","881":"a08d043c","889":"8309e6d0"}[chunkId] + ".chunk.js";
};